import Alice from "../../assets/Screens/Characters/AliceMain.png";

export default function Calendar() {
  return (
    <section id="about" className="md:h-[650px] md:px-[24px]">
      <div className="mx-auto max-w-[995px] w-full h-full pt-[40px] md:pt-0 pb-[22px] md:pb-0 md:relative flex flex-col gap-y-[19px] md:flex-row items-center">
        <div className="z-10 max-w-[315px] md:max-w-[475px] w-full flex flex-col gap-[20px] items-center md:gap-[32px] text-center md:text-left">
          <h2 className="max-w-[230px] md:max-w-none">
            СобеседникИИ - твои надежные компаньоны!
          </h2>
          <p className="subtitle">
            Большой выбор персонажей, из которых можно выбрать себе помощника
            или друга, который сможет поддержать любой диалог и помочь осознать
            свои мысли и эмоции
          </p>
        </div>

        <img
          src={Alice}
          alt="Alice"
          className="md:absolute md:top-1/2 -translate-x-[44px] mb:translate-x-0 md:-translate-y-1/2 md:-right-[96px] lg:-right-[32px] min-w-[404px] h-[519px] md:h-[600px] transition-all"
        />
      </div>
    </section>
  );
}
